/* =========================================================================
   JUSTFYX · Markenwelt A-Z — A-Z-Leiste und Live-Suche
   Lokale Theme-Asset-Datei, wird von sections/jfx-markenwelt.liquid mit
   defer geladen. Reines Vanilla-JS, keine externen Abhaengigkeiten.
   ========================================================================= */

(function () {
  'use strict';
  if (window.__jfxMwInit) return;
  window.__jfxMwInit = true;

  function init() {
    var grid = document.getElementById('jfx-mw-grid');
    var az = document.getElementById('jfx-mw-az');
    var suche = document.getElementById('jfx-mw-suche');
    var leer = document.getElementById('jfx-mw-leer');
    if (!grid || !az) return;

    // A-Z-Leiste aus vorhandenen Buchstaben bauen
    var buchstaben = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
    var vorhanden = {};
    grid.querySelectorAll('[data-mw-letter]').forEach(function (h) { vorhanden[h.dataset.mwLetter] = true; });
    buchstaben.forEach(function (b) {
      var a = document.createElement('a');
      a.textContent = b;
      if (vorhanden[b]) { a.href = '#mw-' + b; } else { a.className = 'ist-leer'; }
      az.appendChild(a);
    });

    if (!suche) return;
    suche.addEventListener('input', function () {
      var q = suche.value.trim().toLowerCase();
      var treffer = 0;
      grid.querySelectorAll('.jfx-mw__item').forEach(function (el) {
        var zeig = !q || el.dataset.mwName.indexOf(q) !== -1;
        el.style.display = zeig ? '' : 'none';
        if (zeig) treffer++;
      });
      grid.querySelectorAll('.jfx-mw__letter').forEach(function (h) {
        var gruppe = h.dataset.mwLetter;
        var sichtbar = [].some.call(grid.querySelectorAll('.jfx-mw__item[data-mw-group="' + gruppe + '"]'), function (el) { return el.style.display !== 'none'; });
        h.style.display = sichtbar ? '' : 'none';
      });
      if (leer) leer.hidden = treffer > 0;
      az.style.visibility = q ? 'hidden' : 'visible';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
